import styled from "styled-components/macro";

import CancelledRespondent from "./CancelledRespondent";

export default function CancellationsList({
  signupItemID,
  cancelledRespondents,
  slotsAvailable,
}) {
  if (!cancelledRespondents) return null;

  return (
    <CancelledRespondentList className="CancelledRespondentsList">
      {cancelledRespondents.map((user, i) => (
        <CancelledRespondent
          key={user.userID}
          highlight={i % 2 === 0}
          signupItemID={signupItemID}
          slotsAvailable={slotsAvailable}
          user={user}
        />
      ))}
    </CancelledRespondentList>
  );
}

const CancelledRespondentList = styled.div`
  position: relative;
  padding: 4px 8px 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
